// src/belediye/services/pushDefteri.js
//
// FAZ-106 — "TELEFONA DÜŞEN BİLDİRİM DEFTERİ" (bu cihaza özel)
//
// ════════════════════════════════════════════════════════════════════════════
// NE ÇÖZÜYOR
//
// Kullanıcı (2026-08-05): "Bir bildirim telefona bildirim olarak düşüyorsa,
// tekrardan uygulama içinde ana ekrana toast olarak düşmesin."
//
// Aynı olay iki kez kesinti yapıyordu: önce kilit ekranında (nöbetçi), sonra
// uygulama açılınca sağ üstte (toast). İkisi de "bak buraya" diyor; ikincisi
// hiçbir şey eklemiyor, yalnız tekrar kapattırıyor.
//
// ════════════════════════════════════════════════════════════════════════════
// NEDEN INDEXEDDB — VE NEDEN SUNUCU DEĞİL
//
// Sorunun doğru sahibi CİHAZDIR, kişi değil. Aynı kullanıcı masaüstünde
// otururken telefonuna bildirim düşmüş olabilir; masaüstünde toast'ı BASTIRMAK
// yanlış olurdu (o ekranda hiçbir şey görmedi). Yani cevap "bu bildirim
// gönderildi mi" değil, "BU CİHAZ bunu zaten gösterdi mi".
//
// Bunu yalnız cihazın kendisi bilir ve tek yazabilen yer nöbetçidir (sw.js).
// Nöbetçinin erişebildiği tek kalıcı depo IndexedDB'dir:
//   • localStorage → nöbetçiden erişilemez (senkron API, SW'de yok).
//   • Cache Storage → FAZ-84 §7.1 gereği bu projede nöbetçiye YASAK; oraya bir
//     kez dokunmak "uygulama bozulamaz" güvencesini çökertir.
//   • Sunucu → nöbetçi oturumu okuyamaz; kimliksiz bir yazma ucu açmak gerekirdi.
//
// ════════════════════════════════════════════════════════════════════════════
// SÖZLEŞME (public/sw.js İLE BİREBİR)
//
// Nöbetçi bu dosyayı import EDEMEZ (paket dışıdır). Bu yüzden aşağıdaki üç
// sabit sw.js içinde de elle yazılıdır — push yükü sözleşmesinin (t/b/n/g/s/l)
// push_policy.py ↔ sw.js arasında zaten böyle taşınmasıyla aynı desen.
// ⚠️ Biri değişirse İKİSİ birden değişir.
//
//     DB adı   : "kim-bildirim"     sürüm: 1
//     Depo     : "gosterilen"       anahtar: notification.id (sayı)
//     Değer    : yazılma anı (ms)   → yaşlanma temizliği için
export const DEFTER_DB = "kim-bildirim";
export const DEFTER_SURUM = 1;
export const DEFTER_DEPO = "gosterilen";

// Kayıtlar sonsuza kadar durmaz: 14 gün sonra silinir. Toast zaten yalnız
// OKUNMAMIŞ satırlar için çizilir; iki hafta okunmamış kalan bir bildirimin
// tekrar görünmesi kusur değil, hatırlatmadır.
const YAS_MS = 14 * 24 * 60 * 60 * 1000;

const idb = () => {
  try {
    return typeof indexedDB !== "undefined" && indexedDB ? indexedDB : null;
  } catch (_) {
    return null;
  }
};

/**
 * Bu ortamda defter TUTULABİLİR mi?
 *
 * Tüketicisi toast kapısı: defter varsa okunana kadar toast BEKLETİLİR (yoksa
 * telefonda görülmüş bildirim bir kez daha patlar ve "toast'landı" damgasını
 * yediği için düzeltme şansı kalmaz). Defter YOKSA bekletecek bir şey de
 * yoktur — gecikme saf zarardır.
 *
 * Senkron olması şart: kapının BAŞLANGIÇ değeri buna göre kurulur; asenkron
 * bir yoklama, defteri olmayan ortamda bile ilk çizimi bir tur geciktirirdi.
 */
export const defterKullanilabilir = () => idb() !== null;

/** DB'yi açar. Desteklenmiyorsa / açılamıyorsa null döner (asla patlamaz). */
function ac() {
  return new Promise((cozumle) => {
    const db = idb();
    if (!db) {
      cozumle(null);
      return;
    }
    let istek;
    try {
      istek = db.open(DEFTER_DB, DEFTER_SURUM);
    } catch (_) {
      cozumle(null);
      return;
    }
    istek.onupgradeneeded = () => {
      try {
        const d = istek.result;
        if (!d.objectStoreNames.contains(DEFTER_DEPO)) d.createObjectStore(DEFTER_DEPO);
      } catch (_) {}
    };
    istek.onsuccess = () => cozumle(istek.result || null);
    istek.onerror = () => cozumle(null);
    // Başka bir sekme sürüm yükseltmesini bloklarsa sonsuza kadar bekleme.
    istek.onblocked = () => cozumle(null);
  });
}

/**
 * Bu cihazda telefon bildirimi olarak GÖSTERİLMİŞ bildirim kimlikleri.
 * Yan etki: yaşlanmış kayıtlar aynı geçişte silinir.
 * @returns {Promise<Set<number>>}
 */
export async function gosterilenleriOku() {
  const out = new Set();
  const d = await ac();
  if (!d) return out;
  return new Promise((cozumle) => {
    let bitti = false;
    const bitir = () => {
      if (bitti) return;
      bitti = true;
      try {
        d.close();
      } catch (_) {}
      cozumle(out);
    };
    try {
      const tx = d.transaction(DEFTER_DEPO, "readwrite");
      const depo = tx.objectStore(DEFTER_DEPO);
      const imdec = depo.openCursor();
      const simdi = Date.now();
      imdec.onsuccess = () => {
        const c = imdec.result;
        if (!c) return;
        const id = Number(c.key);
        const t = Number(c.value) || 0;
        if (t && simdi - t > YAS_MS) {
          try {
            c.delete();
          } catch (_) {}
        } else if (Number.isFinite(id) && id > 0) {
          out.add(id);
        }
        c.continue();
      };
      imdec.onerror = bitir;
      tx.oncomplete = bitir;
      tx.onerror = bitir;
      tx.onabort = bitir;
    } catch (_) {
      bitir();
    }
  });
}

/**
 * Deftere kayıt düşer. Bugün yalnız nöbetçi (sw.js) yazıyor; sayfa tarafı için
 * de dışa açık, çünkü testler defteri buradan kurar — nöbetçiyi jsdom'da
 * çalıştırmak mümkün değil, sözleşmenin doğrulanabilmesi için tek yazma yolu
 * gerekiyor.
 * @param {number} id notification.id
 */
export async function gosterildiYaz(id) {
  const n = Number(id);
  if (!Number.isFinite(n) || n <= 0) return false;
  const d = await ac();
  if (!d) return false;
  return new Promise((cozumle) => {
    try {
      const tx = d.transaction(DEFTER_DEPO, "readwrite");
      tx.objectStore(DEFTER_DEPO).put(Date.now(), n);
      tx.oncomplete = () => {
        try {
          d.close();
        } catch (_) {}
        cozumle(true);
      };
      tx.onerror = () => cozumle(false);
      tx.onabort = () => cozumle(false);
    } catch (_) {
      cozumle(false);
    }
  });
}
